<template>
<div class="productSort"> 
  <div class="index" v-cloak>

    <div class="hotList">
      <div class="hot-bg">
        <div class="title acea-row">
          <div class="text line1">
            <span class="iconfont icon-haibao"></span>
            <span class="label">粤海铁路轮渡欢迎你！</span>
          </div> 
        </div>
      </div>
      <!-- 中国大陆居民  -->
      <div class="list">
          <div style="height:0.2rem;"></div>  
          <div class="container">
            <span class="tabs" :class="{to_active:isShow === 1}" @click="handleTab(1)"><span style="font-size: 0.4rem">开票申请</span></span>
 
          </div>
          <!-- 中国大陆居民  -->  
            <view class="item"></view>    
            <div class="item">
              <div class="acea-row">
                <div style="display:flex;flex-direction:row;align-items: center;">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-cuxiaoguanli"></use>
                    </svg>
                    &nbsp;&nbsp;
                    <input
                      style="width:5rem;"
                      type="text"
                      placeholder="输入电子凭证编号"
                      v-model="chinaParams.business_no"
                      maxlength="30"
                      required
                    />
                </div>
              </div>
            </div>

          <div class="item" style="width:5rem">
              <div class="acea-row">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-shujutongji"></use>
                </svg>&nbsp;&nbsp;开票类型
              </div> 
            </div>

            <div class="container"> 
                <div class="logininit" :class="{ loginbg: cid === 1 }" @click="chinesecheck(1)">个人</div>  
                <div class="logininit" :class="{ loginbg: cid === 2 }" @click="chinesecheck(2)">企业</div>  
            </div>

            <div class="item" style="width:5rem">
              <div class="acea-row">
                  <div style="display:flex;flex-direction:row;width: 5rem;align-items: center;">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-yonghu1"></use>
                    </svg>
                    &nbsp;&nbsp;
                    <input
                      style="width:5rem;"                          
                      type="text" 
                      :placeholder="psdPlaceholder"
                      v-model="chinaParams.name"
                      maxlength="40"
                      required
                    />
                  </div>
              </div>
            </div> 
 
            <div class="item" style="width:5rem" v-show="cid == 2">
              <div class="acea-row">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-xiangxishuju"></use>
                </svg>&nbsp;&nbsp;增值税发票
              </div> 
            </div>

            <div class="container" v-show="cid == 2"> 
                <span class="logininit" :class="{ loginbg: fid === 1 }" @click="foreigncheck(1)">普通发票</span>  
                <span class="logininit" :class="{ loginbg: fid === 2 }" @click="foreigncheck(2)">专用发票</span> 
            </div>
    
            <div class="item" v-show="cid == 2">
              <div class="acea-row">
                  <div style="display:flex;flex-direction: row;align-items: center;">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-code_"></use>
                    </svg>
                    &nbsp;&nbsp;
                    <input
                      style="width:5rem;"                          
                      type="text"
                      placeholder="请输入纳税人识别号"
                      v-model="chinaParams.ticket_no"
                      maxlength="40"
                      required
                    />
                  </div>
              </div>
            </div>

            <div class="item" v-show="cid == 2 && fid == 2">
              <div class="acea-row">
                  <div style="display:flex;flex-direction: row;align-items: center;">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-huiyuan"></use>
                    </svg>
                    &nbsp;&nbsp;
                    <input
                      style="width:5rem;"                          
                      type="text"
                      placeholder="请输入开户银行"
                      v-model="chinaParams.bank_name"
                      maxlength="40"
                      required
                    />
                  </div>
              </div>
            </div>

            <div class="item" v-show="cid == 2 && fid == 2">
              <div class="acea-row">
                  <div style="display:flex;flex-direction: row;align-items: center;">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-yingyongchengxu-xianxing"></use>
                    </svg>
                    &nbsp;&nbsp;
                    <input
                      style="width:5rem;"                          
                      type="text"
                      placeholder="请输入开户账户"
                      v-model="chinaParams.bank_code"
                      maxlength="30"
                      required
                    />
                  </div>
              </div>
            </div>

            <div class="item">
              <div class="acea-row">
                  <div style="display:flex;flex-direction: row;align-items: center;">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-phone_"></use>
                    </svg>
                    &nbsp;&nbsp;
                    <input
                      style="width:5rem;"                          
                      type="text"
                      :placeholder="psdPlaceholder2"
                      v-model="chinaParams.mobile"
                      maxlength="20"
                      required
                    />
                  </div>
              </div>
            </div>

            <div class="item">
              <div class="acea-row">
                  <div style="display:flex;flex-direction: row;align-items: center;">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-yingyongchengxu"></use>
                    </svg>
                    &nbsp;&nbsp;
                    <input
                      style="width:5rem;"                          
                      type="text"
                      placeholder="请输入电子信箱"
                      v-model="chinaParams.email"
                      maxlength="20"
                      required
                    />
                  </div>
              </div>
            </div>
            
            <div class="item" v-show="cid == 2 && fid == 2">
              <div class="acea-row">
                  <div style="display:flex;flex-direction: row;align-items: center;">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-tianjiadizhi"></use>
                    </svg>
                    &nbsp;&nbsp;
                    <input
                      style="width:5rem;"                          
                      type="text"
                      placeholder="请输入专票邮寄地址"
                      v-model="chinaParams.address"
                      maxlength="50"
                      required
                    />
                  </div>
              </div>
            </div> 
            
            <div class="item">   
                <!-- 虚框容器 -->
                  <div class="dashed-border-container">
                    <VueCoreImageUpload 
                      :crop="false"
                      compress="80"
                      @imageuploaded="imageuploaded"
                      :headers="headers"
                      :max-file-size="62914560"
                      :credentials="false"
                      inputAccept="image/*"
                      inputOfFile="file"
                      :url="url"
                      class="custom-uploader"
                    >
                      <!-- 上传提示文字 -->
                      <div v-if="!chinaParams.imageUrl" class="upload-hint">
                        <i class="fas fa-upload"></i>
                        <p>请拍摄保险代保凭证</p>
                        <p class="hint-small">支持JPG、PNG格式，最多1张40M。</p>
                      </div>
                      
                      <!-- 已上传图片预览 -->
                      <div v-if="chinaParams.imageUrl" class="image-preview">
                        <img :src="chinaParams.imageUrl" alt="已上传图片" class="preview-img">
                        <button @click="handleReplace" class="replace-btn">
                          <i class="fas fa-edit"></i> 替换图片
                        </button>
                      </div>
                    </VueCoreImageUpload>
                  </div>
                    
            </div>
            <div class="item" style="height: 9.00em;"></div>

        </div> 
      </div>
      <!--   底部   --> 
      <div style="text-align:center;padding-top: 0.3rem;">
        <button :disabled="sendAuthCode==false"  style="width:6rem;height: 0.8rem;line-height: 0.8rem;background-color:#327bdc;;border-radius:0.10rem;color:white;font-weight:bolder;"  @click="chinaPost()">{{content}}</button>
      </div>
      <div style="text-align:center;padding-top: 0.3rem;">客服电话：182 8948 0966</div> 
  </div>
</div>
</template> 
<script src="http://pv.sohu.com/cityjson?ie=utf-8"></script>

<script>
import { VUE_APP_API_URL } from "@utils";
import GoodList from "@components/GoodList";
import PromotionGood from "@components/PromotionGood";
import { Toast } from 'vant';
import { chinaresidents } from "@api/railway";
import getUserIP from "@api/getip";
import VueCoreImageUpload from "vue-core-image-upload";

export default {
  name: "Index",
  components: {
    GoodList,
    PromotionGood,
    Toast,
    chinaresidents,
    getUserIP,
    VueCoreImageUpload
  },

  data: function() {
    return { 
      ip: '',
      initurl: '',
      banner: [], 
      isShow: 1,
      cid: 1,
      fid: 1,
      cagreen: false,
      isDefault: false,
      content: '提交申请', // 按钮里显示的内容
      totalTime: 60, //记录具体倒计时时间
      sendAuthCode:true,  /*布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */
      chinaParams: {
        // business_no:'YB20220627160437346001',
        // name: '海口韦德沃德信息技术有限公司',
        // id_type: '1',
        // ticket_type: '1',
        // ticket_no: '91320594MA1MD7FF70',
        // bank_name: '交通银行海南省分行营业部',
        // bank_code: 'USA001234343',
        // mobile: '15952405321',
        // email: 'zds00584@ly.com',
        // address: '海南省海口市粤海铁路秀英港12号',

        business_no:'',
        name: '',
        id_type: '1',
        ticket_type: '1',
        ticket_no: '',
        bank_name: '',
        bank_code: '',
        mobile: '',
        email: '',
        address: '',
        imageUrl: ''
      },
      pic: "/insurance_img/1/1.jpeg",
      typeList: [
        {
          text: '中国大陆居民'
        },
        {
          text: '含港澳台证件号'
        }
      ],
      url: `${VUE_APP_API_URL}/api/upload`,
      headers: {
        Authorization: "Bearer " + this.$store.state.app.token
      },
      expect: "",
      unique: this.$route.params.id
    };
  },

  watch: {
    $route(n) {
      if (n.name === NAME && this.unique !== n.params.id) {
        this.unique = n.params.id;
        this.$set(this.scoreList[0], "index", -1);
        this.$set(this.scoreList[1], "index", -1);
        this.expect = "";
        this.uploadPictures = [];
      }
    }
  },

  mounted: function() {
      this.handleTab(1);
      this.chinesecheck(1);
  },
  
  computed: {
    psdPlaceholder() {
      return this.cid == 1
        ? "请输入您的真实姓名"
        : "请输入您的企业名称";
    },

    psdPlaceholder2() {
      return this.cid == 1
        ? "请输入您的联系电话"
        : "请输入企业的联系电话";
    },
  },

  methods: {
    imageuploaded(res) {
    if (res.errno !== 0) return this.$dialog.error(res.msg || "上传图片失败");
      //this.uploadPictures.push(res.link);
      this.chinaParams.imageUrl =res.link;
    },

    // 处理上传错误
    handleUploadError(err) {
      console.error('上传错误', err);
      // 超过数量限制时的提示
      if (err.message.includes('maxFileCount')) {
        alert('最多只能上传1张图片');
      }
    },
    // 替换图片（清空现有图片，允许重新上传）
    handleReplace() {
      this.imageUrl = '';
      // 如果需要主动触发文件选择对话框，可以添加相应逻辑
    },
    
    choose(index) {
      this.selectid = index;
    },

    handleTab(val) {
      this.isShow = val; 
    },
    
    chinesecheck(id){
      this.cid = id;
      this.chinaParams.id_type = id;
      this.chinaParams.name = ""; 
      this.chinaParams.ticket_no = "";
      this.chinaParams.bank_name = "";
      this.chinaParams.bank_code = "";
      this.chinaParams.address = ""; 
      this.chinaParams.imageUrl= "";
    },

    foreigncheck(id){
      this.fid = id;
      this.chinaParams.ticket_type = id;
      if(id == 2)
      {
        this.chinaParams.bank_name = "";
        this.chinaParams.bank_code = "";
        this.chinaParams.address = "";
      }
    },

    //确认协议
    radioChange: function() {
      if(this.chinaParams.cagreen == false)
      {
        this.chinaParams.cagreen = true;
      } else {
        this.chinaParams.cagreen = false;
      } 
      //this.$toast("cagreen:"+this.chinaParams.cagreen);
    },
 
    //开票提交
    chinaPost:function(){ 
      if(this.chinaParams.business_no == "" || this.chinaParams.business_no.length > 30)
      {
         this.$toast("输入正确的电子凭证编号!");
         return;
      }
      if(this.chinaParams.name == "" || this.chinaParams.name.length > 40)
      {
        if(this.chinaParams.id_type == 1){
          this.$toast("请输入您正确的姓名!");
          return;
        } else {
          this.$toast("请输入您正确的企业名称!");
          return;
        }
      }
      //企业普票
      if(this.chinaParams.id_type == 2 && this.chinaParams.ticket_type == 1){
          if(this.chinaParams.ticket_no  == ""  || this.chinaParams.ticket_no.length > 40)
          {
            this.$toast("请输入正确的纳税人识别号!");
            return;
          }

      }
      //企业专票
      if(this.chinaParams.id_type == 2 && this.chinaParams.ticket_type == 2){
          if(this.chinaParams.ticket_no  == ""  || this.chinaParams.ticket_no.length > 40)
          {
            this.$toast("请输入正确的纳税人识别号!");
            return;
          }
          if(this.chinaParams.bank_name  == ""  || this.chinaParams.bank_name.length > 40)
          {
            this.$toast("请输入正确的开户银行!");
            return;
          }

          if(this.chinaParams.bank_code  == ""  || this.chinaParams.bank_code.length > 30)
          {
            this.$toast("请输入正确的开户账户!");
            return;
          }
      }

      if(this.chinaParams.id_type == 1 )
      {
        if(this.chinaParams.mobile  == ""  || this.chinaParams.mobile.length  > 20)
        { 
          this.$toast("请输入您正确的联系电话!");
          return;
        }  
      }

      if(this.chinaParams.id_type == 2 )
      {
        if(this.chinaParams.mobile  == ""  || this.chinaParams.mobile.length > 20)
        { 
          this.$toast("请输入企业正确的联系电话!");
          return;
        }  
      }

      if(this.chinaParams.email  == ""  || this.chinaParams.email.length > 20)
      {
         this.$toast("请输入正确的电子信箱!");
         return;
      }

      if(this.chinaParams.id_type == 2 && this.chinaParams.ticket_type == 2){
        if(this.chinaParams.address  == ""  || this.chinaParams.address.length > 50)
        {
          this.$toast("请输入正确的专票邮寄地址!");
          return;
        }
      }

      if(this.chinaParams.imageUrl  == ""){
        this.$toast("请拍摄船票并上传!");
         return;
      }
 
      //组织数据
      var param = new URLSearchParams();
      param.append("business_no",this.chinaParams.business_no)
      param.append("name",this.chinaParams.name)
      param.append("id_type",this.chinaParams.id_type)
      param.append("ticket_type",this.chinaParams.ticket_type)
      param.append("ticket_no",this.chinaParams.ticket_no)
      param.append("bank_name",this.chinaParams.bank_name)
      param.append("bank_code",this.chinaParams.bank_code)
      param.append("mobile",this.chinaParams.mobile)
      param.append("email",this.chinaParams.email)
      param.append("address",this.chinaParams.address)
      param.append("readme","0.0.0.0")
      param.append("address",this.chinaParams.address)
      param.append("imageUrl",this.chinaParams.imageUrl)

      let that = this;
      that.$dialog.confirm({
        title: '温馨提示',
        mes: "确认要提交开票申请吗?",
        opts: () => {
              chinaresidents(param).then(res => {
              that.message = res.data.message;
              that.message_id = res.data.message_id;
              that.$dialog.message(that.message); 
              //----------//
              that.sendAuthCode = false; 
              let clock = window.setInterval(() => {
                that.totalTime--
                that.content = this.totalTime + 's后才能重新操作'
                if(that.totalTime<=0){
                    that.sendAuthCode = true;
                    clearInterval(clock);
                    that.content = '提交申请';
                    that.totalTime = 60;
                    that.chinaParams.business_no = '';
                    that.chinaParams.name = '';
                    that.chinaParams.id_type = '1',
                    that.chinaParams.ticket_type = '1',
                    that.chinaParams.ticket_no = '';
                    that.chinaParams.bank_name = '';
                    that.chinaParams.bank_code = '';
                    that.chinaParams.mobile = '';
                    that.chinaParams.email = '';
                    that.chinaParams.address = '';
                    that.chinaParams.imageUrl = '';
                }
              },1000);

            },
            err => {
              that.$dialog.message(err.msg);
            }
          );
        }
      }); 

      //提交后台 
      // let that = this;
      // chinaresidents(param).then(res => {
      //     that.message = res.data.message;
      //     that.message_id = res.data.message_id; 
      //     that.$dialog.message(that.message); 
      //   },
      //   err => {
      //     that.$dialog.message(err.msg);
      //   }
      // ); 
 
    },
    //-----------------------------------------------//
    //agreen
    radioChange2: function() {
      if(this.foreignParams.cagreen2 == false)
      {
        this.foreignParams.cagreen2 = true;
      } else 
      {
        this.foreignParams.cagreen2 = false;
      } 
      this.$toast("cagreen2:"+this.foreignParams.cagreen2);
    },

    //-----------开始-----------//
     
    //----------结束------------//
  }
};
</script>
<style scoped>
.to_active {
  color: #327bdc;
  font-weight: bolder;
}
.tabs {
  min-width: 140rpx;
  min-height: 40rpx;
  font-size: 50rpx;
  display: flex;
  align-items: center; 
  text-align: center;
  font-weight: bolder;
}
.tabs2 {
  min-width: 140rpx;
  font-size: smaller;
  display: inline-block;
  min-height: 20rpx;
  align-items: center; 
  text-align: center;
  font-weight: bolder;
}
.to_buttom1 {
  color: #327bdc;
  font-weight: 800;
}

.to_buttom2 {
  color: #327bdc;
  font-weight: 800;
}
 
.loginbg{ 
    background-color:#579afe;
    font-size:0.2rem;
    color:#fff;
}

.logininit {
  width:2rem;
  font-size:0.2rem;
  border-radius:0.1rem; 
  border:0.5px solid #999;
  text-align:center;
  line-height:0.6rem;
}

.disabled{
  background-color: #ddd;
  border-color: #ddd;
  color:#57a3f3;
  cursor: not-allowed; 
}

</style>

<style scoped>
.image-upload-container {
  width: 100%;
  max-width: 600px;
  margin: 20px auto;
}

/* 虚框容器样式 */
.dashed-border-container {
  width: 100%;
  height: 180px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.dashed-border-container:hover {
  border-color: #42b983;  /* Vue标志性绿色 */
  background-color: rgba(66, 185, 131, 0.05);
}

/* 上传提示文字样式 */
.upload-hint {
  text-align: center;
  color: #666;
  padding: 20px;
}

.upload-hint i {
  font-size: 32px;
  margin-bottom: 15px;
  color: #999;
}

.upload-hint p {
  margin: 5px 0;
  font-size: 16px;
}

.hint-small {
  font-size: 14px;
  color: #999;
}

/* 图片预览样式 */
.image-preview {
  width: 100%;
  height: 100%;
  position: relative;
}

.preview-img {
  width: 100%;
  height: 100%;
  object-fit: contain;  /* 保持图片比例，完整显示在容器内 */
}

/* 替换图片按钮 */
.replace-btn {
  position: absolute;
  bottom: 45%;
  right: 35%;
  background-color: rgba(0, 0, 0, 0.5);
  color: rgb(233, 4, 4);
  border: none;
  padding: 6px 12px;
  border-radius: 0px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: background-color 0.3s;
}

.replace-btn:hover {
  background-color: rgba(0, 0, 0, 0.7);
}

/* 隐藏原始上传按钮样式（可选） */
::v-deep .vue-core-image-upload {
  width: 100%;
  height: 100%;
}

::v-deep .vue-core-image-upload input[type="file"] {
  width: 100%;
  height: 100%;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
}
</style>
